import { paths } from "./Constant";
import Login from "../pages/Login/login";
import Profile from "../pages/Profile/Profile";
import AddProfile from "../pages/Profile/AddProfile";
import CreateProfile from "../pages/Login/CreateProfile";
import Documents from "../pages/Documents/Documents";
import Agreements from "../pages/Agreements/Agreements";
import JobOpenings from "../pages/JobOpenings/JobOpening";
import Interviews from "../pages/Interview";
import ApproveDecline from "../pages/Home/ApproveDecline";
import JobDetails from "../pages/jobDetails/JobDetails";

const {
  login,
  agreement,
  document,
  createProfile,
  profile,
  addProfile,
  home,
  homeLanding,
  jobOpenings,
  interviews,
  jobDetails,
} = paths;

export const routes = {
  Login: {
    path: login,
    component: Login,
    exact: true,
    private: false,
  },
  ApproveDecline: {
    path: home,
    component: ApproveDecline,
    exact: true,
    private: true,
  },
  Profile: {
    path: profile,
    component: Profile,
    exact: true,
    private: true,
  },
  AddProfile: {
    path: addProfile,
    component: AddProfile,
    exact: true,
    private: true,
  },
  CreateProfile: {
    path: createProfile,
    component: CreateProfile,
    exact: true,
    private: false,
  },
  Agreements: {
    path: agreement,
    component: Agreements,
    exact: true,
    private: true,
  },
  Documents: {
    path: document,
    component: Documents,
    exact: true,
    private: true,
  },
  HomeLanding: {
    path: homeLanding,
    component: JobOpenings,
    exact: true,
    private: true,
  },
  JobOpenings: {
    path: jobOpenings,
    component: JobOpenings,
    exact: true,
    private: true,
  },
  Interviews: {
    path: interviews,
    component: Interviews,
    exact: true,
    private: true,
  },
  JobDetails: {
    path: jobDetails,
    component: JobDetails,
    exact: true,
    private: true,
  },
};

export const renderRoutes = Object.entries(routes);
